<template lang="pug">
  .sep(v-html='wave')
</template>

<script>
  export default {
    data () {
      return {
        wave: require('@/assets/img/donauhof-seperator.svg')
      }
    }
  }
</script>

<style lang="scss">
  @import "~utils";
  .sep {
    width: 4.6875rem;
    display: block;
    margin: $gutter*2 0;
    svg {
      width: 4.6875rem;
      height: 0.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Seperator.vue?3fce1903